module.exports = __webpack_public_path__ + "assets/webgl/LM_2_0.62fd437b.jpg";